/* tslint:disable */
/* eslint-disable */
/**
 * Bonds API
 * Microservice backend for bond management
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CategoryEnum } from './CategoryEnum';
import {
    CategoryEnumFromJSON,
    CategoryEnumFromJSONTyped,
    CategoryEnumToJSON,
} from './CategoryEnum';
import type { EntityEnum } from './EntityEnum';
import {
    EntityEnumFromJSON,
    EntityEnumFromJSONTyped,
    EntityEnumToJSON,
} from './EntityEnum';
import type { SeverityEnum } from './SeverityEnum';
import {
    SeverityEnumFromJSON,
    SeverityEnumFromJSONTyped,
    SeverityEnumToJSON,
} from './SeverityEnum';
import type { UpdateIssue } from './UpdateIssue';
import {
    UpdateIssueFromJSON,
    UpdateIssueFromJSONTyped,
    UpdateIssueToJSON,
} from './UpdateIssue';
import type { UpdateTypeEnum } from './UpdateTypeEnum';
import {
    UpdateTypeEnumFromJSON,
    UpdateTypeEnumFromJSONTyped,
    UpdateTypeEnumToJSON,
} from './UpdateTypeEnum';

import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
dayjs.extend(utc);
dayjs.extend(timezone);
/**
 * 
 * @export
 * @interface Update
 */
export interface Update {
    /**
     * 
     * @type {Date}
     * @memberof Update
     */
    readonly createdAt: Date;
    /**
     * 
     * @type {EntityEnum}
     * @memberof Update
     */
    entity: EntityEnum;
    /**
     * 
     * @type {string}
     * @memberof Update
     */
    entityId: string;
    /**
     * 
     * @type {UpdateTypeEnum}
     * @memberof Update
     */
    type: UpdateTypeEnum;
    /**
     * 
     * @type {CategoryEnum}
     * @memberof Update
     */
    category: CategoryEnum;
    /**
     * 
     * @type {SeverityEnum}
     * @memberof Update
     */
    severity: SeverityEnum;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof Update
     */
    data: { [key: string]: any; };
    /**
     * 
     * @type {string}
     * @memberof Update
     */
    readonly name: string;
    /**
     * 
     * @type {Array<UpdateIssue>}
     * @memberof Update
     */
    readonly companyIssues: Array<UpdateIssue> | null;
}

/**
 * Check if a given object implements the Update interface.
 */
export function instanceOfUpdate(value: object): boolean {
    if (!('createdAt' in value)) return false;
    if (!('entity' in value)) return false;
    if (!('entityId' in value)) return false;
    if (!('type' in value)) return false;
    if (!('category' in value)) return false;
    if (!('severity' in value)) return false;
    if (!('data' in value)) return false;
    if (!('name' in value)) return false;
    if (!('companyIssues' in value)) return false;
    return true;
}

export function UpdateFromJSON(json: any): Update {
    return UpdateFromJSONTyped(json, false);
}

export function UpdateFromJSONTyped(json: any, ignoreDiscriminator: boolean): Update {
    if (json == null) {
        return json;
    }
    return {
        
        'createdAt': (dayjs(json['created_at']).toDate()),
        'entity': EntityEnumFromJSON(json['entity']),
        'entityId': json['entity_id'],
        'type': UpdateTypeEnumFromJSON(json['type']),
        'category': CategoryEnumFromJSON(json['category']),
        'severity': SeverityEnumFromJSON(json['severity']),
        'data': json['data'],
        'name': json['name'],
        'companyIssues': (json['company_issues'] == null ? null : (json['company_issues'] as Array<any>).map(UpdateIssueFromJSON)),
    };
}

export function UpdateToJSON(value?: Update | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'entity': EntityEnumToJSON(value['entity']),
        'entity_id': value['entityId'],
        'type': UpdateTypeEnumToJSON(value['type']),
        'category': CategoryEnumToJSON(value['category']),
        'severity': SeverityEnumToJSON(value['severity']),
        'data': value['data'],
    };
}

